import { params } from "../../vars/params";
import { config } from "../../../config";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const btnFixed = (): void => {
  const btnFixed = document.querySelectorAll(".c-btn-fixed");
  if (btnFixed.length === 0) return;
  btnFixed.forEach((btnFixed) => {
    ScrollTrigger.create({
      trigger: 'body',
      endTrigger: '.l-footer',
      start: "top -100%",
      end: "top 100%",
      toggleClass: { targets: btnFixed, className: "--show" },
      toggleActions: "play none none reverse",
    });
  });
};